
// Base column configuration
const baseOnlineOrderListColConfig = [
    {
        "label_of_column": "Order ID",
        "name_of_db_column": "orderId",
        "order_of_column": 1,
        "hideSortIcon": true,
    },
    {
        "label_of_column": "Order State",
        "name_of_db_column": "orderState",
        "order_of_column": 2,
        "hideSortIcon": true,
        "colorCode": true
    },
    {
        "label_of_column": "Order Type",
        "name_of_db_column": "orderType",
        "order_of_column": 3,
        "filterVariant": 'dropdown',
        "filterable": true,
        "hideSortIcon": true,
        "defaultFilterValue": "1P",
        "featureFlag": "showOrderTypeFeature", // Use feature flag instead of country code
        "dropdownOptions": [
            { id: "1P", displayText: "1P" },
            { id: "3P", displayText: "3P" }
        ]
    },
    {
        "label_of_column": "Order Sub State",
        "name_of_db_column": "orderSubState",
        "order_of_column": 4,
        "filterable": false,
        "hideSortIcon": true,
    },
    {
        "label_of_column": "Order Date",
        "name_of_db_column": "orderDate",
        "order_of_column": 5,
        "filterVariant": 'dateRange',
        "filterable": false,
    },
    {
        "label_of_column": "Store ID",
        "name_of_db_column": "storeId",
        "order_of_column": 6,
    },
    {
        "label_of_column": "Sold Customer ID",
        "name_of_db_column": "soldCustomerId",
        "order_of_column": 7,
    },
    {
        "label_of_column": "Delivery Date",
        "name_of_db_column": "deliveryDate",
        "order_of_column": 8,
        "filterVariant": 'date',
        "filterable": false,
        "hideSortIcon": true,
    },
    {
        "label_of_column": "Date Updated",
        "name_of_db_column": "updatedDate",
        "order_of_column": 9,
        "filterVariant": 'date',
        "filterable": false,
    },
    {
        "label_of_column": "Local Delivery Date",
        "name_of_db_column": "localDeliveryDate",
        "order_of_column": 10,
        "filterVariant": 'date',
        "filterable": false,
        "hideSortIcon": true,
    }
];

// Export the base configuration (unfiltered)
export const OnlineOrderListColConfig = baseOnlineOrderListColConfig;